// 演目順ページの並び正規化と dirty 判定用シリアライズ。
const clamp = (n, lo, hi) => Math.min(Math.max(n, lo), hi);

// part を 1..max に収め、部ごとに連続するよう安定ソート（部数は基本設定で決定）
export const normalizeParts = (arr, max) =>
  arr
    .map((p) => ({ ...p, part: clamp(p.part || 1, 1, max) }))
    .sort((a, b) => a.part - b.part);

// dirty 判定用シリアライズ（並び＋部）
export const serialOrder = (arr) => arr.map((p) => `${p.id}:${p.part || 1}`).join(",");
